document.addEventListener('DOMContentLoaded', () => {
    
    const menuSliders = document.querySelectorAll(".menu-slider-wrapper");

    if( menuSliders.length ) {

        const Flickity = require("flickity");

        menuSliders.forEach( slider => {


            if( slider.querySelectorAll(".menu-slider-cell").length > 1 ) {

                const flkty = new Flickity( slider, {
                    cellAlign: "center",
                    // contain: true,
                    draggable: true,
                    percentPosition: true,
                    pageDots: false,
                    prevNextButtons: true,
                });
            }

        })

    }

})